<template>
  <div class="ExpireRemind flex" v-if="showRemind && expire_date">
    <div class="remind-box flex">
      <img
        class="tip-img"
        src="../../../assets/images/activity/icon-tip.png"
        alt
        srcset
      />
      <div>您的充值票将于{{ expire_date }}到期</div>
      <img
        @click="closeRemind"
        class="close-img"
        src="../../../assets/images/activity/icon-close.png"
        alt
        srcset
      />
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import { setItem } from '../../../utils'
export default {
  props: {
  },
  data() {
    return {
      showRemind: false,
      expire_date: null
    };
  },
  methods: {
    /**
     *
     *
     * 显示气泡
    */
    showBubble (date) {
      this.showRemind = true
      this.expire_date = date
    },
    /**
     *
     *
     *
     * 关闭气泡
    */
    closeRemind () {
      this.showRemind = false
      setItem('remindDate', moment().format('YYYY-MM-DD'))
    }
  }
};
</script>

<style scoped lang="scss">
.ExpireRemind {
  position: fixed;
  top: 120px;
  width: 100%;
  justify-content: center;
  align-items: center;
  .remind-box {
    width: 500px;
    height: 50px;
    background-color: rgba(0, 0, 0, 0.6);
    align-items: center;
    font-size: 24px;
    color: #ffffff;
    justify-content: space-between;
    div {
      flex: 1;
      padding-left: 20px;
    }
    .tip-img {
      width: 34px;
      height: 34px;
      padding-left: 20px;
    }
    .close-img {
      width: 24px;
      height: 24px;
      padding-right: 20px;
    }
  }
}
</style>
